import { FC } from 'react';
import { Modal, ModalProps } from '@lambdacurry/component-library';
import { AddPaymentMethodForm } from './AddPaymentMethodForm';
import { useStripeSetupIntent } from '../../../hooks';
import { StripeFormWrapper } from '../../Forms';
import { Loading } from '../../Loading';

export interface AddPaymentMethodModalProps extends ModalProps {
  redirectPath?: string;
  onSave: () => void;
  onCancel: () => void;
}

export const AddPaymentMethodModal: FC<AddPaymentMethodModalProps> = ({ onSave, onCancel, redirectPath, ...props }) => {
  const { clientSecret } = useStripeSetupIntent();

  if (!clientSecret) return null;

  return (
    <Modal id="add-payment-method-modal" {...props}>
      <h3>Add a New Payment Method</h3>
      <StripeFormWrapper clientSecret={clientSecret}>
        <AddPaymentMethodForm redirectPath={redirectPath} onSave={onSave} onCancel={onCancel} />
      </StripeFormWrapper>
    </Modal>
  );
};
